import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BaseRepository} from "./base/base.repository";

@Injectable({
    providedIn: 'root'
})
export class MenuItemRepository extends BaseRepository {
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.path = 'dashboard/admin/menu-items';
    }

    getLoggedInUserWithMenuItems() {
        const path = 'dashboard/admin/users/logged-in';
        return super.get(path);
    }

}
